// extracted by mini-css-extract-plugin
export default {"modal":"IModal_modal__1eoE9","close":"IModal_close__8V7t+","body":"IModal_body__t6UCO"};